import { Box, Button, Stack } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Error404 = function Error404() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var router = useRouter();
  return /*#__PURE__*/_jsxs(Stack, {
    h: "full",
    w: "full",
    align: "center",
    pt: 30,
    justify: "center",
    e2eid: "components_Error404_Stack",
    children: [/*#__PURE__*/_jsx("img", {
      style: {
        width: 420
      },
      src: "/404.png",
      e2eid: "components_Error404_img"
    }), /*#__PURE__*/_jsx(Stack, {
      py: "2",
      px: "5",
      align: "end",
      e2eid: "components_Error404_Stack",
      children: /*#__PURE__*/_jsx(Box, {
        e2eid: "components_Error404_Box",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return router.back();
          },
          e2eid: "components_Error404_Button",
          children: t('common:backToPrevPage', '返回上一頁')
        })
      })
    })]
  });
};

export default Error404;